// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SSGj","colBig":"styles_colBig__3MLbU","colSmall":"styles_colSmall__3265O"};